
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/data-deletion",
      function () {
        return require("private-next-pages/data-deletion/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/data-deletion"])
      });
    }
  